import { X } from 'lucide-react';

export default function JobsBulkActions({ selectedCount, onClear, canDeleteJob = true }) {
    if (selectedCount === 0) return null;

    return (
        <div className="fixed top-16 left-1/2 -translate-x-1/2 z-40 bg-white rounded-xl shadow-xl border border-gray-200 px-4 py-2.5 flex items-center gap-4 text-xs animate-in fade-in slide-in-from-top">
            <div className="flex items-center gap-2">
                <button onClick={onClear} className="p-1.5 hover:bg-gray-100 rounded">
                    <X className="w-4 h-4 text-gray-600" />
                </button>
                <span className="font-semibold">{selectedCount} selected</span>
            </div>
            <div className="h-8 w-px bg-gray-300" />
            <button className="px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-medium">
                Schedule
            </button>
            <button className="px-3 py-1.5 border border-gray-300 rounded-lg text-xs font-medium">
                Create Invoice
            </button>
        </div>
    );
}